import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[numbersOnly]'
})
export class NumberOnlyDirective {
  constructor() {
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const code = event.which || event.keyCode;
    if (code === 46 || code === 45) {
      return !input.value.includes('.');
    }
    if (code >= 48 && code <= 57) return true;
    event.preventDefault();
    return false;
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedData = clipboardData.getData('text');
    const regex = /^\d*\.?\d*$/;
    if (!regex.test(pastedData)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value: any = input.value;
    if (value === '') return;
    const num: any = Number(value);
    if (isNaN(num)) {
      input.value = '';
      return;
    }
    const minAttr: any = input.getAttribute('min');
    const maxAttr: any = input.getAttribute('max');
    const min: any = minAttr !== null ? Number(minAttr) : undefined;
    const max: any = maxAttr !== null ? Number(maxAttr) : undefined;
    if (min !== undefined && num < min) {
      input.value = String(min);
    } else if (max !== undefined && num > max) {
      input.value = String(max);
    }
  }
}
